import {h, Component} from "preact"

export default class Popup extends Component {
    constructor() {
        super();
        this.state = {
            isOpen: true
        }
    }

    handleClick = () => {
        this.setState({isOpen: false});
    };

    render({data, options}, {isOpen}) {
        return (
            <div className={`ipolicy__root`}>
                <div
                    className={`ipolicy__container`}
                    style={{
                        display: isOpen
                            ? "block"
                            : "none"
                    }}
                >
                    <b>{data.companyName}</b> uses browser cookies to give you the best possible experience.
                    By using Medium, you agree to our <a href="#">Privacy Policy</a>

                    <button
                        className={`ipolicy__button`}
                        onClick={this.handleClick}
                    >
                        <svg
                            width="19"
                            height="19"
                            viewBox="0 0 19 19"
                        >
                            <path d="M13.792 4.6l-4.29 4.29-4.29-4.29-.612.613 4.29 4.29-4.29 4.29.613.612 4.29-4.29 4.29 4.29.612-.613-4.29-4.29 4.29-4.29" fill-rule="evenodd"></path>
                        </svg>
                    </button>
                </div>
            </div>
        )
    }
}